import sdl from '@jds/react-generated-sdl/JDSFileUploaderItem';
import type { JDSFileUploaderItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFileUploaderItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'loading',
    kind = 'normal',
    showDivider = true,
    ariaLabel = props.message?.toString(),
    suffixAriaLabel = 'Remove File',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, kind, showDivider, ariaLabel, suffixAriaLabel, ...rest },
    'JDSFileUploaderItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FileUploaderItem = withLogic(
  Component
) as React.FC<JDSFileUploaderItemProps> & { slotName?: string };

FileUploaderItem.displayName = 'FileUploaderItem';
FileUploaderItem.slotName = 'jds_file_uploader_item';

export { FileUploaderItem, type JDSFileUploaderItemProps };
